import * as type from "../types";
import moment from "moment-timezone";
import CarStatusLabel from "../../components/CarComponents/Table/CarStatusLabel";
import React from "react";

const sampleGprsOptions = [
    {id: 1, name: 'Podłączony', label: <CarStatusLabel status={'Podłączony'}/>},
    {id: 2, name: 'Rozłączony', label: <CarStatusLabel status={'Rozłączony'}/>},
    {id: 3, name: 'Rozłączony+', label: <CarStatusLabel status={'Rozłączony+'}/>}
];

const initialState = {
    searchField: "",
    group: "",
    brand: "",
    model: "",
    gprs: "",
    fuelType: "",
    gearbox: "",
    gprsOptions: sampleGprsOptions,
    modelOptions: [],
    groupOptions: [],
    brandOptions: [],
    allModelOptions: [],
    fuelTypeOptions: [],
    gearboxOptions: [],
    drive: true,
    refuel: false,
    outOfZone: false,
    warnings: false,
    inService: false,
    showArchived: false,
    showNotArchived: true,
    showPoiOnMap: true,
    startDate: moment().subtract(3, 'days').startOf("day").unix(),
    endDate: moment().endOf('day').unix(),
    street: "",
    city: "",
    postalCode: "",
    radius: "",
};

export default function (state = initialState, action) {
    switch (action.type) {
        case type.SET_SEARCH_FIELD:
            return {
                ...state,
                searchField: action.value
            };
        case type.CHANGE_GROUP_FILTER:
            return {
                ...state,
                group: action.value
            };
        case type.CHANGE_BRAND_FILTER:
            return {
                ...state,
                brand: action.value
            };
        case type.CHANGE_MODEL_FILTER:
            return {
                ...state,
                model: action.value
            };
        case type.CHANGE_FUEL_TYPE_FILTER:
            return {
                ...state,
                fuelType: action.value
            };
        case type.CHANGE_GEARBOX_FILTER:
            return {
                ...state,
                gearbox: action.value
            };
        case type.CHANGE_GPRS_FILTER:
            return {
                ...state,
                gprs: action.value
            };
        case type.CHANGE_DRIVE_FILTER:
            return {
                ...state,
                drive: !state.drive
            };
        case type.SET_DRIVE_FILTER:
            return {
                ...state,
                drive: action.value
            };
        case type.CHANGE_REFUEL_FILTER:
            return {
                ...state,
                refuel: !state.refuel
            };
        case type.CHANGE_WARNINGS_FILTER:
            return {
                ...state,
                warnings: !state.warnings
            };
        case type.CHANGE_REGION_FILTER:
            return {
                ...state,
                outOfZone: !state.outOfZone
            };
        case type.CHANGE_INSERVICE_FILTER:
            return {
                ...state,
                inService: !state.inService
            };
        case type.SHOW_INSERVICE_FILTER:
            return {
                ...state,
                inService: true
            };
        case type.CHANGE_SHOW_ARCHIVED_FILTER:
            return {
                ...state,
                showArchived: !state.showArchived
            };
        case type.SHOW_ARCHIVED_FILTER:
            return {
                ...state,
                showArchived: true
            };
        case type.SHOW_POI_ON_MAP_FILTER:
            return {
                ...state,
                showPoiOnMap: !state.showPoiOnMap
            };
        case type.CHANGE_SHOW_NOT_ARCHIVED_FILTER:
            return {
                ...state,
                showNotArchived: !state.showNotArchived
            };
        case type.CHANGE_START_DATE:
            return {
                ...state,
                startDate: action.value
            };
        case type.CHANGE_END_DATE:
            return {
                ...state,
                endDate: action.value
            };
        case type.CHANGE_FILTERS_DEFAULT:
            return {
                ...initialState,
                endDate: moment().endOf('day').unix(),
                groupOptions: state.groupOptions,
                brandOptions: state.brandOptions,
                allModelOptions: state.allModelOptions,
                fuelTypeOptions: state.fuelTypeOptions,
                gearboxOptions: state.gearBoxOptions,
                street: '',
                city: '',
                postalCode: '',
                radius: '',
            };
        case type.SET_GROUPS_FILTER:
            return {
                ...state,
                groupOptions: action.value
            };
        case type.SET_BRANDS_FILTER:
            return {
                ...state,
                brandOptions: action.value
            };
        case type.SET_MODELS_FILTER:
            return {
                ...state,
                modelOptions: action.value
            };
        case type.SET_FUELTYPES_FILTER:
            return {
                ...state,
                fuelTypeOptions: action.value
            };
        case type.SET_GEARBOXES_FILTER:
            return {
                ...state,
                gearboxOptions: action.value
            };
        case type.SET_ALL_MODELS_FILTER:
            return {
                ...state,
                allModelOptions: action.value
            };
        case type.ADD_GROUP:
            return {
                ...state,
                groupOptions: [...state.groupOptions, {id: action.id, name: action.name}]
            };
        case type.SET_ADDRESS_STREET:
            return {
                ...state,
                street: action.value
            };
        case type.SET_ADDRESS_CITY:
            return {
                ...state,
                city: action.value
            };
        case type.SET_ADDRESS_POSTAL_CODE:
            return {
                ...state,
                postalCode: action.value
            };
        case type.SET_ADDRESS_RADIUS:
            return {
                ...state,
                radius: action.value
            };
        default:
            return state;
    }
}
